import React, { useMemo, useState } from "react";
import { Container, Row, Col, NavLink } from "reactstrap";
import { NavLink as RRNavLink } from "react-router-dom";
import { MDBIcon } from "mdb-react-ui-kit";
import { Menu, MenuItem } from "@mui/material";
import Decimal from "decimal.js";
import { FACTURA_ACTION_BTN } from "./Util";
import { IMAGE_DEFAULT, LOGO, LOGO_2, LOGO_RESTAURANTE } from "./Image";
import { STATES_FAC_FACTURA } from "./States";
import { DATATABLE_FACTURA } from "./Datatables";
import { imgURLocalImage } from "./Services";

export default function PantallaFactura({
  fetchArticuloByUpc,
  dataItems,
  usr_id,
  usr_nombre,
  usr_perfil,
  usr_modo_tableta,
  usr_print,
  usr_precio,
  dataCompania,
  formClientes,
  setFormClientes,
  dataCliente,
  setModalCliente,
  setModalAddCliente,
  setBasicModalEditCliente,
  setErrorCliente,
  formFactura,
  formFacturaDetalle,
  setFormFacturaDetalle,
  dataFacturaDetalle,
  setdataFacturaLocalStorage,
  formRestaurante,
  setFormRestaurante,
  setModalCash,
  setModalNumber,
  setModalItems,
  onChangeFac_detail,
  handleKeyPress,
  keyPressCantidad,
  inputUpc,
  inputCantidad,
  enableTab,
  dataSeries,
  anchorElSerie,
  openSerie,
  setAnchorElSerie,
  handleClickSeries,
  setFormSerie,
  formPrecio,
  anchorEl,
  open,
  handleClickPrices,
  handleClosePrices,
  setPrecio,
  includes_price,
  deleteRow,
  handleSaveRow,
  setDescuento,
  error,
  error_upc,
  isAddmodalCliente,
  onClickNuevaFactura,
  onClickGuardarOrden,
  onClickOpenPagar,
  onClickSaveFacturaPr,
  fetchReportX,
  setModalAnular,
  fetchListAnulacion,
  setErrorAnulacion,
  setModalCopiaF,
  fetchListFacImprimir,
  fetchCotizacionList,
  setModalCreditos,
  fetchCrCredito,
  fetchOrdenesList,
  setModalRuc,
  setFormRuc,
  setDataRuc,
  updateUsrIdLocal,
  subtotal,
  itbms,
  total,
}) {
  const [buscarProducto, setBuscarProducto] = useState("");
  const [categoriaProducto, setCategoriaProducto] = useState("TODAS");

  const categoriasProductos = useMemo(() => {
    const categorias = [];
    dataItems.forEach((item) => {
      if (item.art_categoria && !categorias.some((cat) => cat.value === item.art_categoria)) {
        categorias.push({
          value: item.art_categoria,
          label: item.cat_descripcion,
        });
      }
    });

    return categorias.sort((a, b) => a.label.localeCompare(b.label));
  }, [dataItems]);

  const dataItemsFiltrados = useMemo(() => {
    const buscar = buscarProducto.trim().toLowerCase();
    return dataItems.filter((item) => {
      const coincideCategoria = categoriaProducto === "TODAS" || item.art_categoria === categoriaProducto;
      const coincideBusqueda =
        buscar.length === 0 || item.art_descripcion?.toLowerCase().includes(buscar) || item.art_upc?.toLowerCase().includes(buscar) || item.cat_descripcion?.toLowerCase().includes(buscar) || item.mar_descripcion?.toLowerCase().includes(buscar) || item.art_referencia?.toLowerCase().includes(buscar);
      return coincideCategoria && coincideBusqueda;
    });
  }, [dataItems, buscarProducto, categoriaProducto]);

  const descuentoTotal = dataFacturaDetalle.reduce((total, item) => total.plus(new Decimal(item.fcd_descuento || 0)), new Decimal(0));
  return (
    <Container className="bg-light border border-0 marginu-p" fluid>
      <div className="fac-page">
        <div className="fac-header">
          <div className="fac-header-left">
            <NavLink
              tag={RRNavLink}
              to="/user/home"
              className="fac-header-btn fac-header-close"
              title="Salir"
              onClick={() =>
                setdataFacturaLocalStorage({
                  dataFacturaDetallePr: [],
                })
              }
            >
              <MDBIcon fas icon="times" />
            </NavLink>
            {(usr_print === "2" || usr_print === "4") && (
              <button
                type="button"
                className="fac-header-btn"
                title="Abrir caja"
                onClick={() => {
                  setModalCash(true);

                  setFormRestaurante({
                    ...formRestaurante,
                    code_cash: "",
                    ord_info_comanda: "",
                    ord_para_llevar: "0",
                  });
                }}
              >
                <MDBIcon fas icon="cash-register" />
              </button>
            )}
            {dataCompania.com_lavanderia !== "1" && (
              <button
                type="button"
                className="fac-header-btn"
                title="Factura"
                onClick={() => {
                  updateUsrIdLocal("3");
                }}
              >
                <MDBIcon fas icon="file-invoice-dollar" />
              </button>
            )}
          </div>
          <div className="fac-header-center">
            <div className="fac-header-title">FACTURA</div>
            <div className="fac-vendedor-badge">
              <span className="fac-vendedor-dot"></span>
              <span>Vendedor: {usr_nombre}</span>
            </div>
          </div>
          <div className="fac-header-right">{usr_perfil === "4" ? <img src={LOGO_RESTAURANTE} className="fac-header-logo" alt="Logo" /> : dataCompania.com_logo === "1" ? <img src={LOGO} className="fac-header-logo" alt="Logo" /> : <img src={LOGO_2} className="fac-header-logo" alt="Logo" />}</div>
        </div>
        <div className="fac-action-nav">
          <FACTURA_ACTION_BTN
            fetchReportX={fetchReportX}
            setModalAnular={setModalAnular}
            fetchListAnulacion={fetchListAnulacion}
            setErrorAnulacion={setErrorAnulacion}
            setModalCopiaF={setModalCopiaF}
            fetchListFacImprimir={fetchListFacImprimir}
            fetchCotizacionList={fetchCotizacionList}
            setModalCreditos={setModalCreditos}
            fetchCrCredito={fetchCrCredito}
            fetchOrdenesList={fetchOrdenesList}
            usr_perfil={usr_perfil}
            setModalRuc={setModalRuc}
            setFormRuc={setFormRuc}
            setDataRuc={setDataRuc}
            dataCompania={dataCompania}
          />
        </div>
        <div className="fac-form">
          <Row className="g-1">
            <Col xs={12} lg={6}>
              <div className="fac-field">
                <span className="fac-label">Cliente</span>
                <div className="fac-input-actions">
                  <input type="text" className="fac-input" value={formClientes.cli_dv.length > 0 ? `${formClientes.cli_nombre} - ${formClientes.cli_ruc} DV ${formClientes.cli_dv}` : formClientes.cli_nombre} disabled />
                  <button
                    type="button"
                    className="fac-icon-btn"
                    title="Buscar cliente"
                    onClick={() => {
                      setModalCliente(true);
                      setErrorCliente("");

                      setFormFacturaDetalle(
                        STATES_FAC_FACTURA({
                          staneName: "formFacturaDetalle",
                          usr_id,
                        })
                      );
                    }}
                  >
                    <MDBIcon fas icon="search" />
                  </button>
                  <button
                    type="button"
                    className="fac-icon-btn fac-icon-add"
                    title="Agregar cliente"
                    onClick={() => {
                      setModalAddCliente(true);
                      setErrorCliente("");

                      setFormClientes(
                        STATES_FAC_FACTURA({
                          staneName: "formClientes",
                          usr_id,
                        })
                      );
                    }}
                  >
                    <MDBIcon fas icon="user-plus" />
                  </button>
                  {formClientes.cli_nombre.length > 0 && formClientes.cli_nombre !== "CONSUMIDOR FINAL" && (
                    <button
                      type="button"
                      className="fac-icon-btn"
                      title="Editar cliente"
                      onClick={() => {
                        setModalAddCliente(true);
                        setErrorCliente("");
                        setBasicModalEditCliente(true);
                      }}
                    >
                      <MDBIcon fas icon="pen" />
                    </button>
                  )}
                </div>
              </div>
            </Col>
            <Col xs={12} lg={6}>
              <div className="fac-field">
                <span className="fac-label">Email</span>
                <input type="text" className="fac-input" value={formClientes.cli_email} placeholder="correo@ejemplo.com" disabled />
              </div>
            </Col>
          </Row>
          <Row className="g-1 fac-articulo-row">
            <Col xs={12} lg={4}>
              <div className="fac-field">
                <span className="fac-label">Código o referencia</span>
                <div className="fac-input-actions">
                  <input id="art_upc" name="art_upc" type="text" className="fac-input" placeholder="Código" value={formFacturaDetalle.art_upc} disabled={enableTab} ref={inputUpc} onChange={onChangeFac_detail} onKeyDown={(e) => handleKeyPress(e, formFactura.fcd_articulo)} />
                  {formClientes.cli_nombre.length > 0 && (
                    <button type="button" className="fac-icon-btn" title="Buscar artículo" onClick={() => setModalItems(true)}>
                      <MDBIcon fas icon="search" />
                    </button>
                  )}
                  {formClientes.cli_nombre.length > 0 && formFacturaDetalle.art_descripcion.length > 0 && (
                    <button
                      type="button"
                      className="fac-icon-btn fac-icon-clear"
                      title="Limpiar"
                      onClick={() => {
                        setFormFacturaDetalle(
                          STATES_FAC_FACTURA({
                            staneName: "formFacturaDetalle",
                            usr_id,
                          })
                        );
                      }}
                    >
                      <MDBIcon fas icon="times" />
                    </button>
                  )}
                </div>
              </div>
            </Col>
            <Col xs={12} lg={4}>
              <div className="fac-field">
                <span className="fac-label">Descripción artículo</span>
                <div className="fac-input-actions">
                  <input id="art_descripcion" name="art_descripcion" type="text" className="fac-input" placeholder="Descripción del artículo" value={formFacturaDetalle.art_descripcion} onChange={onChangeFac_detail} disabled={!(formFacturaDetalle.fcd_articulo.length > 0 && usr_precio === "1")} />
                  {dataSeries.length > 0 && (
                    <>
                      <button type="button" id="fac-series-button" className="fac-icon-btn" title="Seleccionar serie" disabled={formFacturaDetalle.art_upc.length === 0} onClick={handleClickSeries}>
                        <MDBIcon fas icon="barcode" />
                      </button>
                      <Menu
                        id="fac-series-menu"
                        anchorEl={anchorElSerie}
                        open={openSerie}
                        onClose={() => setAnchorElSerie(null)}
                        MenuListProps={{
                          "aria-labelledby": "fac-series-button",
                        }}
                      >
                        {dataSeries.map((data, i) => (
                          <MenuItem
                            key={i}
                            onClick={() => {
                              setFormFacturaDetalle({
                                ...formFacturaDetalle,
                                ser_id: data.ser_id,
                                ser_serie: data.ser_serie,
                                art_descripcion: `${formFacturaDetalle.art_descripcion} (SERIE : ${data.ser_serie})`,
                              });
                              setFormSerie([data]);
                              setAnchorElSerie(null);
                            }}
                          >
                            {"SERIE : " + data.ser_serie}
                          </MenuItem>
                        ))}
                      </Menu>
                    </>
                  )}
                </div>
              </div>
            </Col>
            <Col xs={7} sm={7} lg={2}>
              <div className="fac-field">
                <span className="fac-label">Precio</span>
                <div className="fac-input-actions">
                  <input id="fcd_precio" name="fcd_precio" type="number" min="1" className="fac-input fac-input-number" value={formFacturaDetalle.fcd_precio} onChange={onChangeFac_detail} disabled={!(formFacturaDetalle.fcd_articulo.length > 0 && usr_precio === "1")} />
                  <button type="button" id="fac-price-button" className="fac-price-btn" title="Seleccionar precio" onClick={handleClickPrices} disabled={formFacturaDetalle.art_upc.length === 0}>
                    <MDBIcon fas icon="link" />
                  </button>
                  <Menu
                    id="fac-price-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClosePrices}
                    MenuListProps={{
                      "aria-labelledby": "fac-price-button",
                    }}
                  >
                    <MenuItem onClick={() => setPrecio(formPrecio.art_precio)}>{formPrecio.art_precio}</MenuItem>
                    <MenuItem onClick={() => setPrecio(formPrecio.art_precio2)}>{formPrecio.art_precio2}</MenuItem>
                    <MenuItem onClick={() => setPrecio(formPrecio.art_precio3)}>{formPrecio.art_precio3}</MenuItem>
                  </Menu>
                  <button type="button" className="fac-percent-btn" title="Precio incluye ITBMS" onClick={includes_price} disabled={formFacturaDetalle.art_upc.length === 0}>
                    <MDBIcon fas icon="percent" />
                  </button>
                </div>
              </div>
            </Col>
            <Col xs={5} sm={5} lg={2}>
              <div className="fac-field">
                <span className="fac-label">Cantidad</span>
                <div className="fac-input-actions">
                  <input
                    id="fcd_cantidad"
                    name="fcd_cantidad"
                    type="number"
                    min="1"
                    max={Number(formFacturaDetalle.inv_qty)}
                    step="0.01"
                    className="fac-input fac-input-number"
                    ref={inputCantidad}
                    value={formFacturaDetalle.fcd_cantidad}
                    disabled={formFacturaDetalle.art_descripcion.length === 0}
                    onChange={onChangeFac_detail}
                    onKeyDown={(e) => handleKeyPress(e, formFacturaDetalle.fcd_cantidad)}
                  />
                  <button
                    type="button"
                    className="fac-add-item-btn"
                    title="Agregar"
                    disabled={!(formFacturaDetalle.fcd_cantidad !== "0" && formFacturaDetalle.art_descripcion.length > 0 && formFacturaDetalle.fcd_precio.length > 0 && formFacturaDetalle.art_upc.length > 0)}
                    onClick={() => keyPressCantidad()}
                  >
                    <MDBIcon fas icon="plus" />
                  </button>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="g-1 fac-main-actions">
            <Col xs={12} md={4}>
              {(error_upc.length > 0 || (error.length > 0 && isAddmodalCliente === false)) && (
                <div className="fac-errors">
                  {error_upc.length > 0 && <span>{error_upc}</span>}

                  {error.length > 0 && isAddmodalCliente === false && <span>{error}</span>}
                </div>
              )}
            </Col>
            <Col xs={6} md={2}>
              <button type="button" className="fac-main-btn fac-main-new" disabled={dataCliente.length === 0} onClick={() => onClickNuevaFactura()}>
                <MDBIcon fas icon="file-medical" />
                NUEVO
              </button>
            </Col>
            <Col xs={6} md={2}>
              <button type="button" className="fac-main-btn fac-main-save" disabled={dataFacturaDetalle[0] === undefined} onClick={() => onClickGuardarOrden()}>
                <MDBIcon fas icon="save" />
                GUARDAR
              </button>
            </Col>
            <Col xs={6} md={2}>
              <button type="button" className="fac-main-btn fac-main-cancel" disabled={!(formClientes.cli_nombre.length > 0 && dataCliente.length > 0)} onClick={() => onClickNuevaFactura()}>
                <MDBIcon fas icon="ban" />
                CANCELAR
              </button>
            </Col>
            <Col xs={6} md={2}>
              <button
                type="button"
                className="fac-main-btn fac-main-pay"
                disabled={!(dataFacturaDetalle[0] !== undefined && formClientes.cli_nombre.length > 0)}
                onClick={() => {
                  if (dataFacturaDetalle[0] !== undefined) {
                    onClickOpenPagar();
                  }
                }}
              >
                <MDBIcon fas icon="credit-card" />
                COBRAR
              </button>
            </Col>
          </Row>
          <div className="fac-secondary-actions">
            {dataCompania.com_lavanderia === "1" && (
              <button
                type="button"
                className="fac-secondary-btn"
                disabled={dataFacturaDetalle[0] === undefined}
                onClick={() => {
                  setModalNumber(true);
                  setFormRestaurante({ ...formRestaurante, ord_number: "", ord_info_comanda: "", ord_para_llevar: "0" });
                }}
              >
                <MDBIcon fas icon="receipt" />
                Prefactura
              </button>
            )}
            {(dataCompania.com_lavanderia === "1" || usr_perfil === "4") && (
              <button
                type="button"
                className="fac-secondary-btn"
                disabled={dataFacturaDetalle[0] === undefined}
                onClick={() => {
                  setFormRestaurante({ ...formRestaurante, ord_number: "", ord_info_comanda: "", ord_para_llevar: "0" });
                  onClickSaveFacturaPr({ tipo: "0", pdf: false, prefactura: true });
                }}
              >
                <MDBIcon fas icon="receipt" />
                Precuenta
              </button>
            )}
          </div>
        </div>

        {usr_modo_tableta === "0" ? (
          <>
            <div className="fac-table-section">
              <div className="fac-table-header">
                <span>DETALLE</span>
                <span className="fac-table-count">
                  {dataFacturaDetalle.length} {dataFacturaDetalle.length === 1 ? "artículo" : "artículos"}
                </span>
              </div>
              <div className="fac-mrt-wrapper">
                <DATATABLE_FACTURA deleteRow={deleteRow} handleSaveRow={handleSaveRow} dataFacturaDetalle={dataFacturaDetalle} enableTab={enableTab} usr_precio={usr_precio} isRestaurant={false} setDescuento={setDescuento} usr_perfil={usr_perfil} />
              </div>
            </div>
            <div className="fac-footer">
              <Row>
                <Col sm={4}></Col>
                <Col xs={4} sm={2} className="fac-total-box">
                  <span>SUBTOTAL</span>
                  <b>
                    <small>$</small>
                    {new Decimal(subtotal || 0).toFixed(2)}
                  </b>
                </Col>
                <Col xs={4} sm={2} className="fac-total-box">
                  <span>ITBMS</span>
                  <b>
                    <small>$</small>
                    {new Decimal(itbms || 0).toFixed(2)}
                  </b>
                </Col>
                <Col xs={4} sm={2} className="fac-total-box fac-total-final">
                  <span>TOTAL</span>
                  <b>
                    <small>$</small>
                    {new Decimal(total || 0).toFixed(2)}
                  </b>
                </Col>
              </Row>
            </div>
          </>
        ) : (
          <>
            {" "}
            <div className="fac-pos-layout mt-2">
              <div className="fac-pos-products">
                <div className="fac-pos-header">
                  <div>
                    <span className="fac-pos-title">PRODUCTOS</span>

                    <small>Seleccione un artículo para agregar</small>
                  </div>

                  <span className="fac-table-count">{dataItemsFiltrados.length} artículos</span>
                </div>
                <div className="fac-pos-filters">
                  <div className="fac-pos-search">
                    <MDBIcon fas icon="search" className="fac-pos-search-icon" />

                    <input type="text" value={buscarProducto} onChange={(e) => setBuscarProducto(e.target.value)} placeholder="Buscar código, descripción, marca..." />

                    {buscarProducto.length > 0 && (
                      <button type="button" className="fac-pos-search-clear" onClick={() => setBuscarProducto("")}>
                        <MDBIcon fas icon="times" />
                      </button>
                    )}
                  </div>
                  <select className="fac-pos-category" value={categoriaProducto} onChange={(e) => setCategoriaProducto(e.target.value)}>
                    <option value="TODAS">TODAS LAS CATEGORÍAS</option>
                    {categoriasProductos.map((categoria) => (
                      <option key={categoria.value} value={categoria.value}>
                        {categoria.label}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="fac-pos-products-grid">
                  {dataItemsFiltrados.length === 0 ? (
                    <div className="fac-pos-no-products">
                      <MDBIcon fas icon="search" />
                      <span>No se encontraron productos</span>
                      <small>Intente con otra búsqueda o categoría</small>
                    </div>
                  ) : (
                    dataItemsFiltrados.map((item, index) => {
                      const descripcion = item.art_descripcion || "";
                      const descripcionCorta = descripcion.length > 55 ? descripcion.substring(0, 55) + "..." : descripcion;
                      const imagenProducto = item.art_imgName && item.art_imgName.length > 0 ? imgURLocalImage + item.art_imgName : IMAGE_DEFAULT;
                      return (
                        <button key={item.art_id || index} type="button" className="fac-product-card" onClick={() => fetchArticuloByUpc({ art_upc: item.art_upc, barcode: true, modalItem: false })}>
                          <div className="fac-product-image">
                            <img
                              src={imagenProducto}
                              alt={item.art_descripcion}
                              onError={(e) => {
                                e.currentTarget.onerror = null;
                                e.currentTarget.src = IMAGE_DEFAULT;
                              }}
                            />
                          </div>
                          <div className="fac-product-top">
                            <div className="fac-product-code">{item.art_upc}</div>
                            <div className="fac-product-category">{item.cat_descripcion}</div>
                          </div>
                          <div className="fac-product-description" title={item.art_descripcion}>
                            {descripcionCorta}
                          </div>
                          {item.art_referencia && <div className="fac-product-reference">Ref: {item.art_referencia}</div>}
                          <div className="fac-product-brand">{item.mar_descripcion}</div>
                          <div className="fac-product-bottom">
                            <span className="fac-product-price">${new Decimal(item.art_precio || 0).toFixed(2)}</span>
                            {item.art_servicio === "0" && <span className={`fac-product-stock ${Number(item.inv_qty) <= 0 ? "sin-stock" : ""}`}>Disp. {item.inv_qty}</span>}
                          </div>
                        </button>
                      );
                    })
                  )}
                </div>
              </div>
              <div className="fac-pos-ticket">
                <div className="fac-mrt-wrapper fac-mrt-pos">
                  {dataFacturaDetalle[0] !== undefined && <DATATABLE_FACTURA deleteRow={deleteRow} handleSaveRow={handleSaveRow} dataFacturaDetalle={dataFacturaDetalle} enableTab={enableTab} usr_precio={usr_precio} isRestaurant={true} setDescuento={setDescuento} usr_perfil={usr_perfil} />}
                </div>
                <div className="fac-pos-totals">
                  <div className="fac-pos-total-row">
                    <span>SUBTOTAL</span>
                    <strong>${new Decimal(subtotal || 0).toFixed(2)}</strong>
                  </div>
                  {descuentoTotal.gt(0) && (
                    <div className="fac-pos-total-row fac-pos-total-discount">
                      <span>DESCUENTO</span>
                      <strong>-${descuentoTotal.toFixed(2)}</strong>
                    </div>
                  )}

                  <div className="fac-pos-total-row">
                    <span>ITBMS</span>
                    <strong>${new Decimal(itbms || 0).toFixed(2)}</strong>
                  </div>
                  <div className="fac-pos-total-row fac-pos-total-final">
                    <span>TOTAL</span>
                    <strong>${new Decimal(total || 0).toFixed(2)}</strong>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </Container>
  );
}
